// 封装 路由扩展 函数
'use strict'

import 'es6-promise/auto';

const $routers = [
  {
    "path": "/",
    "name": "MYPRO-HOME",
    "title": "69游戏 李逵劈鱼 - 首页",
    "funcs": { "enable":true,"login":false, "nav":false }
  },
  {
    "path": "/error",
    "name": "MYPRO-ERROR",
    "title": "69游戏 李逵劈鱼 - 哎呀出错啦！",
    "funcs": { "enable":true,"login":false, "nav":false }
  },
  {
    "path": "/appdown",
    "name": "MYPRO-APPSDOWN",
    "title": "69游戏 李逵劈鱼 - 客户端下载",
    "funcs": { "enable":true,"login":false, "nav":false }
  },
  {
    "path": "/scbind",
    "name": "MYPRO-AUTHBIND",
    "title": "69游戏 李逵劈鱼 - 渠道扫码绑定",
    "funcs": { "enable":true,"login":false, "nav":false }
  },
  {
    "path": "/wxauth",
    "name": "MYPRO-BINDDOWN",
    "title": "69游戏 李逵劈鱼 - 授权绑定下载",
    "funcs": { "enable":true,"login":false, "nav":false }
  },
  {
    "path": "/extdata",
    "name": "MYPRO-CHANNEL",
    "title": "69游戏 李逵劈鱼 - 我的推广数据",
    "funcs": { "enable":true,"login":false, "nav":false }
  },
  {
    "path": "/extdown",
    "name": "MYPRO-EXTDOWN",
    "title": "69游戏 李逵劈鱼 - 推广绑定下载",
    "funcs": { "enable":true,"login":false, "nav":false }
  }
];

var navbars = function() { return this; };
/**
 * 根据菜单名称获取导航项
 * @param {string} name 导航名称
 */
navbars.get= function (name) {
  var pitem = undefined;
  if ($routers && $routers.length > 0) {
    for (var i = 0; i < $routers.length; i++) {
      if (pitem === undefined && $routers[i].name === name) {
        pitem = $routers[i];
        break;
      }
    }
  }
  return pitem;
};

export default navbars;




// WEBPACK FOOTER //
// ./src/assets/js/navbar.js